export default __webpack_public_path__ + "static/media/to-do.a4945b4e.svg";